import { render, staticRenderFns } from "./inactive-student.vue?vue&type=template&id=59abf5e0&"
import script from "./inactive-student.vue?vue&type=script&lang=js&"
export * from "./inactive-student.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports